import React from 'react';
import styled from '@emotion/styled';
import _ from 'lodash';

import { COLORS, SPACE, BREAKPOINTS } from '@/constants';
import { ALERT_STATUSES, type AlertStatus } from '@/constants/statuses';
import { Small } from '@/components/type/small';

type AlertWrapperProps = {
  backgroundColor: string;
};

export const AlertWrapper = styled.div<AlertWrapperProps>`
  background-color: ${({ backgroundColor }) => backgroundColor};
  color: ${COLORS.GREY_ELEVEN};
  display: flex;
  padding: ${SPACE.X0};

  @media (min-width: ${BREAKPOINTS.SM}px) {
    padding: 12px;
  }
`;

const StyledContent = styled.span`
  padding-left: ${SPACE.X0};
`;

const IconWrapper = styled.div`
  display: flex;
  align-items: center;
`;

type AlertProps = {
  status: AlertStatus;
  content?: string | React.ReactNode | React.JSX.Element;
};

const Alert = ({ status, content = null }: AlertProps) => {
  if (_.isNil(status) || !_.includes(ALERT_STATUSES, status)) return null;

  const { icon: Icon, backgroundColor, statusContent } = status;

  return (
    <AlertWrapper {...{ backgroundColor }}>
      <IconWrapper>
        <Icon aria-hidden="true" />
      </IconWrapper>
      <StyledContent>
        <Small>{statusContent || content}</Small>
      </StyledContent>
    </AlertWrapper>
  );
};

export default Alert;
